export default __webpack_public_path__ + "static/media/dec2023-5.0042bf3b.jpg";